import classNames from 'classnames'

import './Icon.scss'

type IconColor =
  | 'default'
  | 'white'
  | 'strong'
  | 'danger'
  | 'info'
  | 'warning'
  | 'success'
  | 'ai'
type IconSize = 'sm' | 'md' | 'lg'

interface IconProps {
  icon: string
  className?: string
  color?: IconColor
  size?: IconSize
}

export const Icon: React.FC<IconProps> = ({ icon, color, size, className }) => {
  return (
    <i
      className={classNames(
        `svg-icon icon-${icon}`,
        color,
        size ? `icon-${size}` : undefined,
        className,
      )}
    />
  )
}

export { iconNames } from './const'
export type { IconColor, IconSize }
